import React from 'react';
import { Box, Chip } from '@mui/material';
import {
  Timer as TimerIcon,
  Input as InputIcon,
  Output as OutputIcon,
  Token as TokenIcon,
  AttachMoney as AttachMoneyIcon,
  Memory as MemoryIcon
} from '@mui/icons-material';

const formatTokens = (value) => Number(value).toLocaleString('ru-RU');

const formatTime = (ms) => {
  if (ms < 1000) return `${Math.round(ms)} мс`;
  return `${(ms / 1000).toFixed(1)} с`;
};

/**
 * Ряд чипов с метриками запроса к нейросети.
 * Рендерит только переданные метрики; если ничего нет — null.
 */
const NeuroMetricsChips = ({ timeMs, inputTokens, outputTokens, totalTokens, costUsd, model }) => {
  const chips = [];

  if (timeMs != null) {
    chips.push({ key: 'time', icon: <TimerIcon />, label: formatTime(timeMs) });
  }
  if (inputTokens != null) {
    chips.push({ key: 'input', icon: <InputIcon />, label: `Вход: ${formatTokens(inputTokens)}` });
  }
  if (outputTokens != null) {
    chips.push({ key: 'output', icon: <OutputIcon />, label: `Выход: ${formatTokens(outputTokens)}` });
  }
  if (totalTokens != null) {
    chips.push({ key: 'total', icon: <TokenIcon />, label: `Всего: ${formatTokens(totalTokens)}` });
  }
  if (costUsd != null) {
    chips.push({ key: 'cost', icon: <AttachMoneyIcon />, label: `$${Number(costUsd).toFixed(4)}` });
  }
  if (model) {
    chips.push({ key: 'model', icon: <MemoryIcon />, label: model });
  }

  if (chips.length === 0) return null;

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
      {chips.map((chip) => (
        <Chip
          key={chip.key}
          icon={chip.icon}
          label={chip.label}
          size="small"
          variant="outlined"
        />
      ))}
    </Box>
  );
};

export default NeuroMetricsChips;
